import cn from 'classnames';
import { ComponentRef, forwardRef } from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { TabsContentProps } from '@/shared/ui/core/tabs/model/tabs.types';
import styles from '@/shared/ui/core/tabs/ui/tabs.module.scss';


export const TabsContent = forwardRef<
    ComponentRef<typeof TabsPrimitive.Content>,
    TabsContentProps
>(function TabsContent ({
    className,
    ...props
}, ref) {
    return (
        <TabsPrimitive.Content
            ref={ ref }
            className={ cn(styles.content, className) }
            { ...props }
        />
    );
});
